import React from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import { HashLink as Link } from "react-router-hash-link"

import AccountCircleIcon from "@material-ui/icons/AccountCircle"
import EditIcon from "@material-ui/icons/Edit"
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline"
import OpenInNewIcon from "@material-ui/icons/OpenInNew"

import { selectCourses } from "../../redux/course/course.selectors"
import { selectCurrentUser } from "../../redux/user/user.selectors"

import { selectLanguage } from "../../redux/language/language.selectors"

import EN_DATA from "../../data/language/english.data"
import PT_DATA from "../../data/language/portuguese.data"

import api from "../../services/api"

import "./Dashboard.scss"

class Dashboard extends React.Component {
  constructor() {
    super()

    this.state = {
      userCourses: "",
    }
  }

  async componentDidMount() {
    const userId = localStorage.getItem("userId")

    if (userId) {
      await api.get(`/user-courses/${userId}`).then((response) => {
        this.setState({ userCourses: response.data.course })
      })
    } else {
      this.props.history.push("/login")
    }
  }

  formatSelectedDate(dateKey) {
    if (!dateKey) return ""

    const [year, month, day] = dateKey.split("-")

    if (!year || !month || !day) return ""

    return `${day}/${month}/${year}`
  }

  formatSelectedDateTime(dateKey, hourKey) {
    if (!dateKey) return ""

    const formattedDate = this.formatSelectedDate(dateKey)

    if (!hourKey) return formattedDate

    return `${formattedDate} - ${hourKey}`
  }

  formatDate(date) {
    if (!date) return ""

    const formDate = new Date(date)
    const day = formDate.getDate()
    const year = formDate.getFullYear()
    const month = formDate.getMonth() + 1

    return day + "/" + month + "/" + year
  }

  formatHours(date) {
    if (!date) return ""

    const formDate = new Date(date)
    let hours = formDate.getHours()
    let minutes = formDate.getMinutes()

    if (hours.toString().length === 1) {
      hours = "0" + hours
    }

    if (minutes.toString().length === 1) {
      minutes = "0" + minutes
    }

    return hours + ":" + minutes
  }

  isDeadline(deadline) {
    const formDate = new Date(deadline)
    const today = new Date()

    return this.formatDate(formDate) === this.formatDate(today)
  }

  groupCoursesByQuantity(courses) {
    if (!Array.isArray(courses)) return []

    const map = new Map()

    courses.forEach((item) => {
      const key = `${item._id}__${item.dateCourse || "no-date"}`

      if (!map.has(key)) {
        map.set(key, {
          ...item,
          quantity: item.quantity || 1,
        })
      } else {
        const existing = map.get(key)
        existing.quantity += item.quantity || 1
        map.set(key, existing)
      }
    })

    console.log(Array.from(map.values()))

    return Array.from(map.values())
  }

  render() {
    const { courses, language, currentUser } = this.props
    const { userCourses } = this.state
    const text =
      language === "EN"
        ? EN_DATA.sections.dashboard
        : PT_DATA.sections.dashboard

    return (
      <div className="container dashboard">
        <div className="user">
          <h1>
            {text[0]}, {currentUser?.name}!
          </h1>
          <Link className="edit-button" to={`/edit-user/${currentUser?.id}`}>
            {text[1]}
            <AccountCircleIcon />
          </Link>
        </div>

        {currentUser?.type === 0 ? (
          <div className="admin-dashboard">
            <div className="admin-header">
              <p className="eyebrow">Admin area</p>
              <h2>Manage HeadStart Courses</h2>
              <p className="admin-description">
                Access course management, booking reports, and admin checks from
                one place.
              </p>
            </div>

            <div className="admin-grid">
              <Link className="admin-card" to="/dashboard/courses">
                <div>
                  <h3>Courses</h3>
                  <p>Add, edit, and manage courses shown on the website.</p>
                </div>
                <EditIcon />
              </Link>

              <Link className="admin-card" to="/reports">
                <div>
                  <h3>Reports</h3>
                  <p>
                    View scheduled courses, customer details, vouchers, and
                    sales data.
                  </p>
                </div>
                <OpenInNewIcon />
              </Link>

              <Link className="admin-card" to="/admin-audit">
                <div>
                  <h3>Audit Bookings</h3>
                  <p>
                    Check booking conflicts, overbooked dates, and admin alerts.
                  </p>
                </div>
                <OpenInNewIcon />
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <p>{text[2]}</p>

            {userCourses
              ? this.groupCoursesByQuantity(userCourses).map((course) => (
                  <div key={course?.userCourseId} className="course">
                    <span className="name">
                      {course?.name}
                      {course?.quantity > 1 ? ` (x${course.quantity})` : ""}
                    </span>

                    {!course?.dateCourse && !course?.selectedDateKey ? (
                      ""
                    ) : (
                      <span className="deadline">
                        {text[4]}
                        <b className="line">
                          {course?.selectedDateKey
                            ? this.formatSelectedDateTime(
                                course.selectedDateKey,
                                course.selectedHourKey,
                              )
                            : `${this.formatDate(course?.dateCourse)} - ${this.formatHours(
                                course?.dateCourse,
                              )}`}
                        </b>
                      </span>
                    )}

                    {course?.type === "online" ? (
                      course?.level === 0 &&
                      this.isDeadline(course?.deadline) ? (
                        <Link className="add-button" to="#" disabled={true}>
                          {text[5]}
                        </Link>
                      ) : this.isDeadline(course?.deadline) ? (
                        <Link className="add-button" to="#" disabled={true}>
                          {text[6]}
                        </Link>
                      ) : (
                        <Link
                          className="edit-button"
                          to={`/course/${course._id}`}
                          target="_blank"
                        >
                          {text[7]}
                          <OpenInNewIcon />
                        </Link>
                      )
                    ) : this.isDeadline(course?.deadline) ||
                      course?.dateCourse ? (
                      <Link className="add-button" to="#" disabled={true}>
                        {text[8]}
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                ))
              : ""}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  courses: selectCourses,
  currentUser: selectCurrentUser,
  language: selectLanguage,
})

export default connect(mapStateToProps, null)(Dashboard)
